import template from "./profile-page.html";

const ProfilePageComponent = {
  template: template,

  controller: class ProfilePageController {
    /* @ngInject */
    constructor($rootScope, $scope, $window, $filter, SecurityManager, Notification, FilePicker) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$window = $window;
      this.$filter = $filter;
      this.SecurityManager = SecurityManager;
      this.NotificationService = Notification;
      this.FilePicker = FilePicker;
    }

    $onInit() {
      this.user = this.$rootScope.user;
      this.organization = this.$rootScope.organization;

      // Form models
      this.email = angular.copy(this.user.email);
      this.name = angular.copy(this.user.name);
      this.surname = angular.copy(this.user.surname);
      this.newPassword = null;
      this.repeatPassword = null;

      // Control flags
      this.savingProfile = false;
      this.savingEmail = false;
      this.savingPassword = false;
      this.hasPicture = this.user.hasPicture();

      this.$scope.$on("refreshUser", () => {
        this.user = this.$rootScope.user;
        this.hasPicture = this.user.hasPicture();
      });

      this.$scope.$watch(
        () => this.email,
        (newVal, oldVal) => {
          if (this.emailError && !angular.equals(newVal, oldVal)) this.emailError = false;
        },
      );
    }

    canUpdateProfile() {
      return !(angular.equals(this.name, this.user.name) && angular.equals(this.surname, this.user.surname));
    }

    canUpdateEmail() {
      return !angular.equals(this.email, this.user.email);
    }

    async updateProfileData() {
      if (!this.profileForm.$valid || !this.canUpdateProfile()) {
        return;
      }

      this.savingProfile = true;
      await this.user.update({ name: this.name, surname: this.surname });
      this.user = await this.SecurityManager.refreshUser();
      this.savingProfile = false;
      this.$rootScope.$applyAsync();
    }

    async updateEmail() {
      if (!this.emailForm.$valid || !this.canUpdateEmail()) {
        return;
      }

      this.savingEmail = true;
      try {
        await this.user.update({ email: this.email });
        this.user = await this.SecurityManager.refreshUser();
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.emailUpdated"),
        });
      } catch (e) {
        if (e.data === "Email is already registered") {
          this.emailError = this.$filter("trans")("errors.auth.registeredEmail");
          this.showForgotPassword = true;
        } else {
          throw e;
        }
      }

      this.savingEmail = false;
      this.$rootScope.$applyAsync();
    }

    async updatePassword() {
      if (!this.passwordForm.$valid) {
        return;
      }

      this.savingPassword = true;

      await this.user.update({ password: this.newPassword });
      this.newPassword = null;
      this.repeatPassword = null;
      this.passwordForm.$setPristine();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.passwordUpdated"),
      });

      this.savingPassword = false;
      this.$rootScope.$applyAsync();
    }

    async removePicture() {
      await this.user.updateProfileImage();
      await this.SecurityManager.refreshUser();
      this.$rootScope.$applyAsync();
    }

    async uploadPicture() {
      const metadata = await this.FilePicker.uploadProfileImageV2();
      if (metadata) {
        await this.user.updateProfileImage(metadata);
        await this.SecurityManager.refreshUser();
      }
    }
  },
};

export default ProfilePageComponent;
